export const QUERY_DSN_PARAGRAPH_KEY = "paragraph";
export const QUERY_CENTLEX_ELEMENT_ID_KEY = "centElId";

export const QUERY_SEARCH_WORD_KEY = "word";
export const QUERY_SEARCH_DICTIONARY_KEY = "dict";
export const QUERY_SEARCH_DIRECTION_KEY = "dir";
export const QUERY_SEARCH_FORCE_DIRECTION_KEY = "fdir";

export const QUERY_INFLECTION_SCHEME_ID_KEY = "isid";

export const QUERY_ARTICLE_TAB_KEY = "tab";
export const QUERY_ARTICLE_TAB_TRANSLATIONS_VAL = "translations";
export const QUERY_ARTICLE_TAB_MEANINGS_VAL = "meanings";
export const QUERY_ARTICLE_TAB_COMBINATIONS_VAL = "combinations";
export const QUERY_ARTICLE_TAB_PHRASES_VAL = "phrases";
export const QUERY_ARTICLE_TAB_SYNONYMS_VAL = "synonyms";
export const QUERY_ARTICLE_TAB_DEFINITIONS_VAL = "definitions";
